import {
  APP_LOADING,
  CLEAR,
  ERROR,
  SUCCESS,
} from "../constants/types/alertType";

export const success = (message) => (dispatch) => {
  dispatch({
    type: SUCCESS,
    payload: message,
  });
};
export const error = (message) => (dispatch) => {
  dispatch({
    type: ERROR,
    payload: message,
  });
};
export const clear = (id) => (dispatch) => {
  dispatch({
    type: CLEAR,
    payload: id,
  });
};
export const appLoading = (status) => (dispatch) => {
  dispatch({
    type: APP_LOADING,
    payload: status,
  });
};
